<template>
  <div class="CompatibilityChecker">
    <h1 class="_heading">{{content.heading}}</h1>
    <p class="_subheading">{{content.subheading}}</p>
    <SelectWidget
      :values="values.years"
      :placeholder="content.selectYear"
      :selectedValue="selection.year"
      :selectValue="selectYear"
    ></SelectWidget>
    <div class="_widgetwithspinner">
      <SelectWidget
        :values="values.makes"
        :placeholder="content.selectMake"
        :selectedValue="selection.make"
        :selectValue="selectMake"
      ></SelectWidget>
      <div class="spinner" :hidden="!makesLoading"></div>
    </div>
    <div class="_widgetwithspinner">
      <SelectWidget
        :values="values.models"
        :placeholder="content.selectModel"
        :selectedValue="selection.model"
        :selectValue="selectModel"
      ></SelectWidget>
      <div class="spinner" :hidden="!modelsLoading"></div>
    </div>
    <p class="_fineprint">{{content.fineprint}}</p>
    <CompatibilityStatus :info="compatInfo"></CompatibilityStatus>
  </div>
</template>

<script>
  require('isomorphic-fetch')

  import content from "../../assets/stores.json"

  import SelectWidget from './SelectWidget.vue'
  import CompatibilityStatus from './CompatibilityStatus.vue'

  function makeApiRequest(endpoint, params, check) {
    let requestUrl = `https://vdm.us.vzconnect.com/api/vis/vii/${endpoint}/`
    if (check) {
      requestUrl = `https://vdm.us.vzconnect.com/api/vis/${endpoint}/`
    }
    let options = { region: "US", lineOfBusiness: "SMB" }

    if (params) {
      options = Object.assign(options, params);
    }

    const requestOption = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      multiValueHeaders: { "client-id" : "VZC Digital Marketing - Compatibility Checker - Stores" },
      body: JSON.stringify(options)
    };
    return fetch(requestUrl, requestOption).then(response => response.json())
  }

  export default {
    name: 'CompatibilityChecker',
    data() {
      const values = {
        years: null,
        makes: null,
        models: null,
      }
      const selection = {
        year: null,
        make: null,
        model: null,
      }
      const compatInfo = null
      var makesLoading = false
      var modelsLoading = false
      return { content, values, selection, compatInfo, makesLoading, modelsLoading }
    },
    components: {
      SelectWidget,
      CompatibilityStatus,
    },
    methods: {
      updateSelection(year = null, make = null, model = null) {
        if (year !== this.selection.year) {
          this.$set(this.selection, 'year', year)
          this.$set(this.values, 'makes', null)
        }
        if (make !== this.selection.make) {
          this.$set(this.selection, 'make', make)
          this.$set(this.values, 'models', null)
        }
        if (model !== this.selection.model) {
          this.$set(this.selection, 'model', model)
        }
      },
      selectYear(year) {
        this.updateSelection(year)
        this.$set(this, 'compatInfo', null)
        this.$set(this, 'makesLoading', true)
        makeApiRequest('oem/makes/byyear', { year: year }).then(data => {
          this.$set(this.values, 'makes', data)
          this.$set(this, 'makesLoading', false)
        })
      },
      selectMake(make) {
        if (this.selection.year) {
          const year = this.selection.year
          this.updateSelection(year, make)
          this.$set(this, 'compatInfo', null)
          this.$set(this, 'modelsLoading', true)
          makeApiRequest('oem/models/byyearmake', { year: year, make: make }).then(data => {
            this.$set(this.values, 'models', data)
            this.$set(this, 'modelsLoading', false)
          })
        }
      },
      selectModel(model) {
        if (this.selection.year && this.selection.make) {
          const year = this.selection.year
          const make = this.selection.make
          this.updateSelection(year, make, model)
          this.$set(this, 'compatInfo', { 'loading' : true })

          let params = { deviceType: "VDD", vehicles: [ {make: make, model: model, year: year} ] }

          makeApiRequest('comp/device/support/mmy', params, true).then(data => {
            const vehicle = [year, make, model].join(' ')
            const eventLabel = [year, make, model].join(' / ')
            this.$set(this, 'compatInfo', { vehicle, eventLabel, ...data })
            this.updateSelection()
          })
        }
      },
    },
    created() {
      makeApiRequest('oem/years').then(data => {
        this.$set(this.values, 'years', data)
      })
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/fonts';
  @import '../../assets/spinner';

  .CompatibilityChecker {

    width: 588px;
    max-width: 100%;
    font-family: $display-font;

    ._heading {
      margin: 0;
      font-weight: bold;
      font-size: 36px;
    }

    ._subheading {
      font-size: 20px;
      margin-top: 8px;
    }

    ._widgetwithspinner {
      display: flex;

      .spinner {
        margin: 45px 0 0 30px;

        @media(max-width:479px) {
          display: none;
        }
      }

    }

    ._fineprint {
      font-size: 11px;
      margin-top: 35px;
      margin-bottom: 20px;
    }
  }
</style>
